<template>
  <component :is="layout" class="content">
    <slot />
  </component>
</template>

<script>
const defaultLayout = "AppLoggedInLayout";

const importedLayouts = {};

export default {
  name: "AppLayout",
  components: {},
  computed: {
    layout() {
      const layout = this.$route.meta.layout || defaultLayout;

      // Avoid unnecessary re-render of layouts (dynamic component in the template)
      if (!importedLayouts[layout]) {
        importedLayouts[layout] = () => import(`@/layouts/${layout}.vue`);
      }
      return importedLayouts[layout];
    },
  },
};
</script>
